<ngx-mat-timepicker
	[stepMinute]="5"
	[(ngModel)]="time"
	(ngModelChange)="onTimeChange($event)"
	>
</ngx-mat-timepicker>